<template>
    <div class="page-comments" v-loading="pageLoading">
        <div class="messages">
            <template v-for="(item, index) in items(storePath(path))">
                <div class="message" :key="index" v-if="!item.is_active && (account && account.id === item.user.id)">
                    <div class="head">
                        <div class="author">
                            <svg-icon source="blockquote" />
                            <div class="name">
                                {{ item.user.name }}
                            </div>
                        </div>
                        <div class="actions">
                            <div class="date">
                                <svg-icon source="calendar" /> {{ item.date }}
                            </div>
                            <div class="status" v-if="!item.is_active && (account && account.id === item.user.id)">
                                Onay Bekliyor
                            </div>
                        </div>
                    </div>
                    <div class="body">
                        {{ item.description }}
                    </div>
                </div>
            </template>

            <page-pagination :page="page" :path="path" :pagination="pagination" :change="handleChangePage" />
        </div>

        <div class="title">
            kendi yorumunu <span class="colored-secondary">paylaş</span>
        </div>

        <div class="comment-form">
            <el-form :label-position="'top'" ref="form" :model="form" @submit.native.prevent="store" class="feedback-comment-form">
                <div class="textarea-container" style="padding: 0">
                    <el-form-item :class="{ 'is-error': submitted && $v.form.content.$error }">
                        <el-input v-model="form.content" prefix-icon="el-icon-message" :placeholder="$t('inputs.your_message')" type="textarea" rows="2" />
                    </el-form-item>
                </div>

                <div class="send-comment mt-20">
                    <el-button class="secondary large send-btn" :loading="loading" :disabled="loading" @click="store">
                        Yorumunu Gönder
                    </el-button>
                </div>
            </el-form>
        </div>

    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_REQUEST_ITEMS, STORE_REQUEST_ITEM} from "~/store/actions.type";
import {SET_AUTH_DIALOG} from "~/store/mutations.type";
import {minLength, required} from "vuelidate/lib/validators";

export default {
    name: 'Comment',
    props : ['id'],
    data() {
        return {
            path: 'comments/',
            filter: {
                //
            },
            page: 1,
            pageLoading: true,

            loading: false,
            submitted: false,
            form: {
                //
            },
        }
    },
    validations: {
        form: {
            content: {required, minLength: minLength(10)},
        }
    },
    computed: mapGetters(['pagination', 'items', 'account']),
    mounted() {
        this.path = this.path + this.id;
        this.index();
    },
    methods : {
        handleChangePage(page) {
            this.page = page;
            this.index();
        },

        index() {
            this.pageLoading = true;

            this.$store
                .dispatch(GET_REQUEST_ITEMS, {path: this.path, filter: this.filter, page: this.page})
                .then(() => {
                    this.pageLoading = false;
                })
                .catch(() => {
                    this.pageLoading = false;
                })
        },

        store() {

            if (!this.account) {
                return this.$store.commit(SET_AUTH_DIALOG, true);
            }

            this.submitted = true;

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.loading = true;
            this.form.path = this.path;

            this.$store
                .dispatch(STORE_REQUEST_ITEM, this.form)
                .then(() => {
                    this.submitted = false;
                    this.loading = false;
                    this.form = {
                        //
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.submitted = false;
                });
        },
    }
}
</script>
